<template>
  <div>
    <el-dropdown @command="handleCommand">
      <span class="el-dropdown-link">
        <IconMoreOptionComponent size="small" theme="blue" />
      </span>
      <el-dropdown-menu slot="dropdown">
        <!-- 1. Ver -->
        <el-dropdown-item command="withholding-view">
          <i class="el-icon-view"></i> Ver
        </el-dropdown-item>

        <!-- 2. Enviar documento -->
        <el-dropdown-item command="withholding-send">
          <i class="el-icon-s-promotion"></i> Enviar documento
        </el-dropdown-item>

        <!-- Firmar / Re-intentar firma -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="withholding-signature">
            <i class="el-icon-edit-outline"></i>
            {{ status === "timeout" ? "Re-intentar firma" : "Firmar" }}
          </el-dropdown-item>
        </template>

        <!-- Editar -->
        <template v-if="status === 'draft' || status === 'failed'">
          <el-dropdown-item command="withholding-edit">
            <i class="el-icon-edit"></i> Editar
          </el-dropdown-item>
        </template>

        <!-- Descargar PDF -->
        <el-dropdown-item command="withholding-download">
          <i class="el-icon-download"></i> Descargar PDF
        </el-dropdown-item>

        <!-- Anular -->
        <template v-if="status === 'success'">
          <el-dropdown-item command="withholding-nuled">
            <i class="el-icon-circle-close"></i> Anular retención
          </el-dropdown-item>
        </template>

        <!-- Eliminar (siempre al final) -->
        <template
          v-if="
            status === 'draft' || status === 'failed' || status === 'timeout'
          "
        >
          <el-dropdown-item command="withholding-delete" divided>
            <i class="el-icon-delete"></i> Eliminar
          </el-dropdown-item>
        </template>
      </el-dropdown-menu>
    </el-dropdown>

    <SigningConfirmModal
      :visible.sync="sriModalVisible"
      :documentNumber="withholding ? withholding.identification_document : ''"
      :clientName="
        withholding && withholding.client ? withholding.client.name : ''
      "
      :amount="withholding ? withholding.total : 0"
      @confirm="sendSRI"
    />

    <el-dialog
      width="80%"
      title=""
      :visible.sync="nuledModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea anular la retención?
        </h4>
        <p class="text-color-primary">
          Para completar el proceso de anulación debe ser anulada en el
          <LinkSRI />
        </p>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="nuledModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Anular" @onSaveClick="onNuled" />
        </div>
      </div>
    </el-dialog>

    <el-dialog
      width="200"
      title=""
      :visible.sync="deleteModalVisible"
      append-to-body
    >
      <div class="text-center">
        <img :src="icoNotifyDanger" alt="" width="30" />
        <h4 class="h4 font-semi-bold text-break text-color-primary mt-4">
          ¿Seguro desea eliminar la retención?
        </h4>
        <div class="d-flex justify-content-center align-items-center mt-4">
          <button
            @click="deleteModalVisible = false"
            class="btn md__btn-secondary mr-4"
          >
            Cancelar
          </button>
          <ButtonPrimaryComponent title="Eliminar" @onSaveClick="onDelete" />
        </div>
      </div>
    </el-dialog>

    <WrapperSendDocumentDrawer
      @onDocumentSend="onDocumentSend"
      @onCloseDrawer="visibleDocumentSend = false"
      :visibleDocumentSend="visibleDocumentSend"
      :toMails="toMails"
      :toPhone="toPhone"
      :clientId="
        withholding && withholding.client ? withholding.client.id : null
      "
      :recipientName="
        withholding && withholding.client ? withholding.client.name : ''
      "
      :messageableType="'withholding'"
      :messageableId="id"
      :moduleType="'withholding'"
      :draftKey="'draft-withholding-' + id"
    />
  </div>
</template>

<style lang="scss" scoped>
.img-sm {
  width: 0.8rem !important;
}
</style>

<script>
import WrapperSendDocumentDrawer from "../../../../components/WrapperSendDocumentDrawer";
import withholdingService from "../services/withholdingService";
import IconMoreOptionComponent from "@/components/General/IconMoreOption";
import ButtonPrimaryComponent from "../../../../components/ButtonPrimary";
import LinkSRI from "@/components/General/LinkSRI";
import SigningConfirmModal from "@/components/General/SigningConfirmModal";
import { signingEventBus } from "@/services/signingEventBus";
import {
  icoNotifyDanger,
  iconEdit,
  iconDelete,
  iconNuled,
  iconSend,
  iconDownload,
  icoSignature,
  icoPreview
} from "@/services/resources";
import { downloadFile } from "@/assets/utils/files";

export default {
  name: "WithholdingOptionsByStatus",
  props: ["status", "id"],
  data() {
    return {
      icoNotifyDanger,
      iconEdit,
      iconDelete,
      iconNuled,
      iconSend,
      iconDownload,
      icoSignature,
      icoPreview,
      sriModalVisible: false,
      nuledModalVisible: false,
      deleteModalVisible: false,
      visibleDocumentSend: false,
      withholding: null,
      toMails: [],
      toPhone: ""
    };
  },
  methods: {
    async getWithholding() {
      try {
        let response = await withholdingService.getWithholdingId(this.id);
        if (response) this.withholding = response.data.data;
      } catch (e) {
        return false;
      }
    },
    async handleCommand(command) {
      if (!this.withholding) {
        await this.getWithholding();
        await this.$nextTick();
      }
      switch (command) {
        case "withholding-view":
          this.$emit("goPage", "sales.withholdings.view", { id: this.id });
          break;
        case "withholding-edit":
          this.$emit("goPage", "sales.withholdings.edit", { id: this.id });
          break;
        case "withholding-signature":
          this.sriModalVisible = true;
          break;
        case "withholding-nuled":
          this.nuledModalVisible = true;
          break;
        case "withholding-delete":
          this.deleteModalVisible = true;
          break;
        case "withholding-send":
          this.openSendDrawer();
          break;
        case "withholding-download":
          this.download();
          break;
      }
    },
    async sendSRI() {
      const docId = this.withholding.id;
      const clientName = this.withholding.client
        ? this.withholding.client.name
        : "";
      const documentNumber = this.withholding.identification_document || "";

      this.sriModalVisible = false;
      signingEventBus.$emit("signing:start", {
        id: docId,
        clientName,
        documentNumber
      });
      this.$emit("onSigningStart", docId);

      try {
        let response = await withholdingService.sendWithholdingSRI({
          user_business_withholding_id: docId
        });
        const { success, message, data } = response.data;
        if (success) {
          signingEventBus.$emit("signing:done", {
            id: docId,
            clientName,
            documentNumber
          });
          this.withholding = data;
          this.$emit("onSigningDone", { id: docId, data });
        } else {
          signingEventBus.$emit("signing:error", {
            id: docId,
            message: message || "Error al firmar"
          });
          this.$emit("onSigningError", docId);
        }
      } catch (error) {
        signingEventBus.$emit("signing:error", {
          id: docId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al firmar"
        });
        this.$emit("onSigningError", docId);
      }
    },
    async onNuled() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const docId = this.withholding.id;
        let response = await withholdingService
          .updateWithholdingStatus({ user_business_withholding_id: docId })
          .finally(() => {
            this.$store.dispatch("toggleRequestLoading");
            this.nuledModalVisible = false;
          });
        const { success, message, data } = response.data;
        if (success) {
          this.withholding = data;
          this.$notifications.success({ message });
          this.$emit("onSigningDone", { id: docId, data });
        }
      } catch (e) {
        return false;
      }
    },
    async onDelete() {
      try {
        const docId = this.withholding.id;
        let response = await withholdingService
          .deleteWithholdingId(docId)
          .finally(() => {
            this.deleteModalVisible = false;
          });
        const { success, message } = response.data;
        if (success) {
          this.$notifications.success({ message });
          this.$emit("onDocDeleted", docId);
        }
      } catch (e) {
        return false;
      }
    },
    async download() {
      this.$store.dispatch("toggleRequestLoading");
      try {
        const { identification_document, id } = this.withholding;
        let response = await withholdingService
          .withholdingDownload({ id })
          .finally(() => this.$store.dispatch("toggleRequestLoading"));
        if (response.data)
          downloadFile(
            response.data,
            `Retencion - #${identification_document}`
          );
      } catch (e) {
        return false;
      }
    },
    openSendDrawer() {
      const client = this.withholding?.client;
      this.toMails = client && client.email ? [client.email] : [];
      this.toPhone = client && client.phone ? String(client.phone).trim() : "";
      this.visibleDocumentSend = true;
    },
    async onDocumentSend({ data }) {
      data.append("withholding_id", this.withholding.id);

      const emailId = `email-withholding-${Date.now()}`;
      const clientName = this.withholding?.client?.name || "";
      const docNumber = this.withholding?.identification_document || "";

      this.visibleDocumentSend = false;

      signingEventBus.$emit("email:start", {
        id: emailId,
        clientName,
        documentNumber: `Retención #${docNumber}`
      });

      try {
        let response = await withholdingService.sendWithholdingEmail({ data });
        const { success, message } = response.data;
        if (success) {
          signingEventBus.$emit("email:done", {
            id: emailId,
            clientName,
            documentNumber: `Retención #${docNumber}`
          });
        } else {
          signingEventBus.$emit("email:error", {
            id: emailId,
            message: message || "Error al enviar el documento"
          });
        }
      } catch (error) {
        signingEventBus.$emit("email:error", {
          id: emailId,
          message:
            error?.response?.data?.message ||
            error?.message ||
            "Error al enviar"
        });
      }
    }
  },
  components: {
    IconMoreOptionComponent,
    ButtonPrimaryComponent,
    WrapperSendDocumentDrawer,
    LinkSRI,
    SigningConfirmModal
  }
};
</script>
